import { render, staticRenderFns } from "./imperialSetting.vue?vue&type=template&id=4aff9020&scoped=true&"
import script from "./imperialSetting.vue?vue&type=script&lang=js&"
export * from "./imperialSetting.vue?vue&type=script&lang=js&"
import style0 from "./imperialSetting.vue?vue&type=style&index=0&id=4aff9020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff9020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aff9020')) {
      api.createRecord('4aff9020', component.options)
    } else {
      api.reload('4aff9020', component.options)
    }
    module.hot.accept("./imperialSetting.vue?vue&type=template&id=4aff9020&scoped=true&", function () {
      api.rerender('4aff9020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/NavbarMenu/components/SettingAndTools/imperialSetting.vue"
export default component.exports